import { useMutation } from "@tanstack/react-query";

import axios from "../../../../api/axios";

interface CommentReportRequest {
  commentId: number;
  reasonId: number;
  description?: string;
}

const reportComment = async (data: CommentReportRequest) => {
  const response = await axios.post("/reports/comments", data);
  return response.data;
};

export const useCommentReportMutation = () => {
  return useMutation({
    mutationFn: reportComment,
    onSuccess: () => {},
  });
};
